import { useAuthDialogStore } from '@/features/auth/stores/auth-dialog'
import { PublicKeyAuthDialog } from './PublicKeyAuthDialog'
import { ForgotPasswordDialog } from './ForgotPasswordDialog'
import { SignInDialog } from './SignInDialog'
import { SignUpDialog } from './SignUpDialog'
import type { PublicKeyAuthAction, PublicKeyAuthMethod } from '../types'

function parsePublicKeyAuthView(
  view: string
): { method: PublicKeyAuthMethod; action: PublicKeyAuthAction } | null {
  const [method, action, extra] = view.split('-')
  if (extra) return null
  if (method !== 'lnurl' && method !== 'auth47') return null
  if (action !== 'login' && action !== 'signup' && action !== 'link') return null

  return { method, action }
}

export function AuthDialogs() {
  const view = useAuthDialogStore((state) => state.view)
  const isOpen = useAuthDialogStore((state) => state.isOpen)
  const close = useAuthDialogStore((state) => state.close)
  const switchView = useAuthDialogStore((state) => state.switchView)
  const onSuccess = useAuthDialogStore((state) => state.onSuccess)
  const publicKeyView = parsePublicKeyAuthView(view)

  if (publicKeyView) {
    const { method, action } = publicKeyView
    return (
      <PublicKeyAuthDialog
        action={action}
        method={method}
        onClose={close}
        onSuccess={onSuccess ?? undefined}
        open={isOpen}
        switchToSignin={() => switchView(`${method}-login`)}
        switchToSignup={() => switchView(`${method}-signup`)}
      />
    )
  }

  if (view === 'forgot-password') return <ForgotPasswordDialog />

  return view === 'signin' ? <SignInDialog /> : <SignUpDialog />
}
